import $ from 'jquery';

$(function () {
	const load_more_buttons = $('.js-load-more-articles');
	const $load_more_reports = $( '.js-load-more-reports' );
	const $load_more_articles = $( '.js-load-more-campaign-articles' );

	const addReadingTime = function() {
		if ($('.js-has-reading-time').length) {
			$('.js-has-reading-time').each( function() {
				const $readingTime = $( this ).find( '.js-reading-time' );
				const $content = $( this ).find( '.js-reading-content' );

				if ( $readingTime.html() ) {
					return;
				}

				if ( $readingTime && $readingTime.length && $content && $content.length ) {
					const text = $content[0].textContent;
					const wordCount = text.match(/\S+/g).length;
					const wpm = 250;
					let readingTimeInMinutes = 1;

					const readingTime = wordCount / wpm;
					const readingTimeModulo = readingTime - Math.floor(readingTime);

					if (wordCount > wpm) {
						if ((readingTimeModulo >= 0) && (readingTimeModulo < 0.8)) {
							readingTimeInMinutes = Math.floor(wordCount / wpm);
						} else {
							readingTimeInMinutes = Math.floor(wordCount / wpm) + 1;
						}
					}

					$readingTime.html(readingTimeInMinutes);
				}
			} );
		}
	};

	if( load_more_buttons.length > 0 ){
		load_more_buttons.each( function() {
			var button = $(this);

			var query = button.data('query'),
				max_page = button.data('max-page'),
				current_page = button.data('current-page');

			button.on('click', function () {
				var data = {
					'action': 'loadmore',
					'query': query,
					'page': current_page,
					'daily-2019-ajax': 'true',
					'excludes': button.data('excludes'),
				};

				if ( button.attr( 'data-wrapper-classes' ) ) {
					data.wrapperClasses = button.attr( 'data-wrapper-classes' );
				}

				if ( button.attr( 'data-article-classes' ) ) {
					data.articleClasses = button.attr( 'data-article-classes' );
				}

				$.ajax({
					url: window.emagazine_script.ajax_url, // AJAX handler
					data: data,
					type: 'POST',
					beforeSend: function (xhr) {
						button.find('span').text(window.emagazine_script.loading_text);
						button.attr('disabled', 'disabled');
					},
					success: function (data) {
						if (data) {
							button.find('span').text(window.emagazine_script.after_load_text);

							const html = $.parseHTML(data);

							button.closest('.o-container-fluid').find('.js-latest-posts').append(html); // insert new posts
							addReadingTime();
							button.removeAttr('disabled');

							current_page++
							button.attr('data-current-page', current_page);

							if (current_page > max_page){
								button.remove(); // if last page, remove the button
							}

						} else {
							button.remove(); // if no data, remove the button as well
						}
					}
				});
			});
		});
	}

	if ( $load_more_reports && $load_more_reports.length ) {
		$load_more_reports.on( 'click', function() {
			const $button = $( this );

			let currentPage = $button.attr( 'data-page' );
			const maxPage = $button.attr( 'data-max-page' );

			const offset = currentPage * $button.attr( 'data-posts-per-page' );
			const postID = $button.attr( 'data-post-id' );

			const data = {
				action: 'loadmore-reports',
				offset: offset,
				postID: postID,
				perPage: $button.attr( 'data-posts-per-page' ),
				'daily-2019-ajax': 'true',
			};

			$.ajax({
				url: window.emagazine_script.ajax_url, // AJAX handler
				data: data,
				type: 'POST',
				beforeSend: function (xhr) {
					$button.find('span').text(window.emagazine_script.loading_text);
					$button.attr('disabled', 'disabled');
				},
				success: function (data) {
					if (data) {
						$button.find('span').text(window.emagazine_script.after_load_text);

						const html = $.parseHTML(data);

						$button.closest('.o-container-fluid').find('.js-latest-posts').append(html);
						$button.removeAttr('disabled');

						currentPage++
						$button.attr('data-page', currentPage);

						if (currentPage > maxPage){
							$button.remove();
						}

					} else {
						$button.remove();
					}
				}
			});
		} );
	}

	if ( $load_more_articles && $load_more_articles.length ) {
		$load_more_articles.on( 'click', function() {
			const $button = $( this );

			let currentPage = $button.attr( 'data-page' );
			const maxPage = $button.attr( 'data-max-page' );

			const offset = currentPage * $button.attr( 'data-posts-per-page' );
			const postID = $button.attr( 'data-post-id' );

			const data = {
				action: 'loadmore-campaign-articles',
				offset: offset,
				postID: postID,
				perPage: $button.attr( 'data-posts-per-page' ),
				'daily-2019-ajax': 'true',
			};

			$.ajax({
				url: window.emagazine_script.ajax_url, // AJAX handler
				data: data,
				type: 'POST',
				beforeSend: function (xhr) {
					$button.find('span').text(window.emagazine_script.loading_text);
					$button.attr('disabled', 'disabled');
				},
				success: function (data) {
					if (data) {
						$button.find('span').text(window.emagazine_script.after_load_text);

						const html = $.parseHTML(data);

						$button.closest('.o-container-fluid').find('.js-latest-posts').append(html);
						$button.removeAttr('disabled');

						currentPage++
						$button.attr('data-page', currentPage);

						if (currentPage > maxPage){
							$button.remove();
						}

					} else {
						$button.remove();
					}
				}
			});
		} );
	}


	$('.c-article__content .c-wysiwyg img').each( function() {
		var $img = $(this),
			img_class = 'extra-large';
		if(!$img.parent().is('p') && $img.hasClass(img_class)){
			if($img.parent().hasClass('wp-caption') || $img.parent().parent().hasClass('wp-caption')){
				if($img.parent().is('a')){
					$img.parent().parent().addClass('c-wide-container');
				}else{
					$img.parent().addClass('c-wide-container');
				}
			}else{
				if($img.parent().is('a')){
					$img.parent().wrap('<p class="c-wide-container"></p>');
				}else{
					$img.wrap('<p class="c-wide-container"></p>');
				}
			}
		}
	});
} );
